var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"btn-dark tooltip-cpms",attrs:{"pill":"","size":"sm","id":_vm.id}},[_vm._v("i")]),_vm._v(" "),_c('b-tooltip',{attrs:{"target":_vm.id,"triggers":"hover"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.htmlText)}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf0f81d0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InfoTooltip.vue
// module id = null
// module chunks = 